import omit from 'ramda/src/omit'

export default function clearMultiImagerLenses(state, action) {
  const { id, lensIds } = action
  const { cameras } = state

  const camera = cameras.find(c => c.id === id)
  const updatedCamera = Object.assign({}, omit(['isMultiImager', 'lensIds', 'fixedLensIds'], camera))

  return Object.assign(
    {},
    state,
    {
      cameras: [
        ...cameras.filter(c => c.id !== id && !lensIds.includes(c.id)),
        updatedCamera
      ]
    }
  )
}



// WEBPACK FOOTER //
// ./src/reducers/clearMultiImagerLenses.js